// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!./components/styles/global.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  /* font-size: var(--bs-body-font-size); */
  font-size: 16px;
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  /* color: var(--bs-body-color); */
  text-align: var(--bs-body-text-align);
  /* background: rgba(10,27,27,1); */
  /* color: #fff; */
  /* padding: 1rem; */
  /* background-color: var(--bs-body-color) */
  /* -webkit-text-size-adjust: 100%; */
  /* -webkit-tap-highlight-color: transparent; */
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,yCAAyC;EACzC,eAAe;EACf,uCAAuC;EACvC,uCAAuC;EACvC,iCAAiC;EACjC,qCAAqC;EACrC,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,oCAAoC;EACpC,8CAA8C;AAChD","sourcesContent":["@import './components/styles/global.css';\n\nbody {\n  margin: 0;\n  font-family: var(--bs-body-font-family);\n  /* font-size: var(--bs-body-font-size); */\n  font-size: 16px;\n  font-weight: var(--bs-body-font-weight);\n  line-height: var(--bs-body-line-height);\n  /* color: var(--bs-body-color); */\n  text-align: var(--bs-body-text-align);\n  /* background: rgba(10,27,27,1); */\n  /* color: #fff; */\n  /* padding: 1rem; */\n  /* background-color: var(--bs-body-color) */\n  /* -webkit-text-size-adjust: 100%; */\n  /* -webkit-tap-highlight-color: transparent; */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
